export default "__VITE_ASSET__CezqiRLQ__"